import React from 'react';
import PropTypes from 'prop-types';
import {
  PlantIcon as Normal,
  PlantHighlightIcon as Highlighted,
} from '../../Icons';
import {PlantTooltip} from './PlantTooltip';
import {Image} from '@learningblocks/shared-components';
import className from './style.module.scss';

export function Plant({plantLabel, buttonList}) {
  const [hover, setSelected] = React.useState(false);

  const setImage = () => (hover ? Highlighted : Normal);

  const toggleHover = (value) => () => setSelected(value);

  return (
    <div
      tabIndex='0'
      className={className.plant}
      onMouseEnter={toggleHover(true)}
      onMouseLeave={toggleHover(false)}>
      <PlantTooltip plantLabel={plantLabel} selected={hover}  buttonList={ buttonList }/>
      <Image src={setImage()} alt='plant' />
    </div>
  );
}

Plant.propTypes = {
  /**
   * Lael for the plant
   */
  plantLabel: PropTypes.string,
};

Plant.defaultProps = {
  plantLabel: '',
};
